import { useCallback, useEffect, useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

import { IDLE_COSTS_QUERY_PARAM } from 'features/cost-report/constants';
import { usePersistentState } from '@cast/utils';

type Result = {
  includeIdleCosts: boolean;
  updateIdleCosts: (value: boolean) => void;
};

export const useCostReportIdleCosts = (): Result => {
  const [includeIdleCosts, setIncludeIdleCosts] = usePersistentState<boolean>(
    'cost-report.idle-costs',
    false
  );
  const [searchParams, setSearchParams] = useSearchParams();

  const idleCostsFromUrl = useMemo(() => {
    return searchParams.get(IDLE_COSTS_QUERY_PARAM);
  }, [searchParams]);

  useEffect(() => {
    // url param has higher priority to allow link sharing
    if (idleCostsFromUrl !== null) {
      setIncludeIdleCosts(idleCostsFromUrl === 'true');
    }
  }, [idleCostsFromUrl, setIncludeIdleCosts]);

  const updateIdleCosts = useCallback(
    (value: boolean) => {
      setIncludeIdleCosts(value);
      setSearchParams((it) => {
        it.set(IDLE_COSTS_QUERY_PARAM, String(value));
        return it;
      });
    },
    [setSearchParams, setIncludeIdleCosts]
  );

  return {
    includeIdleCosts,
    updateIdleCosts,
  };
};
